import './Select.css';

import { cnDeprecated } from '../../utils/bem';

export const COMPONENT_NAME = 'Select' as const;
export const cnSelect = cnDeprecated(COMPONENT_NAME);
